import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOperations = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "ç¼ç»",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path 13",
				d: "M1.66669 4.16671C1.66669 3.70647 2.03978 3.33337 2.50002 3.33337H17.5C17.9603 3.33337 18.3334 3.70647 18.3334 4.16671V15.8334C18.3334 16.2936 17.9603 16.6667 17.5 16.6667H2.50002C2.03978 16.6667 1.66669 16.2936 1.66669 15.8334V4.16671Z",
				stroke: "",
				strokeWidth: 1.4,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path 28",
				d: "M1.66669 6.66671H18.3334",
				stroke: "",
				strokeWidth: 1.4,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path 29",
				d: "M11.25 13.3333H15",
				stroke: "",
				strokeWidth: 1.4,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path 30",
				d: "M18.3333 4.16663V10.8333",
				stroke: "",
				strokeWidth: 1.4,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path 31",
				d: "M1.66669 4.16663V10.8333",
				stroke: "",
				strokeWidth: 1.4,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgOperations;
